"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defineInspect;
var _invariant = _interopRequireDefault(require("./invariant.js"));
var _nodejsCustomInspectSymbol = _interopRequireDefault(require("./nodejsCustomInspectSymbol.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */
function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || (0, _invariant["default"])(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (_nodejsCustomInspectSymbol["default"]) {
    classObject.prototype[_nodejsCustomInspectSymbol["default"]] = fn;
  }
}